const infoCards = [

    {
        nombreCard: ["Por primera vez"],
        listadoBeneficios: [
            "Gestión del trámite de Reprocann.",
            "Consulta médica.",
            "Acompañamiento en el trámite hasta obtener el permiso.",
            "Posibilidad de cultivo de hasta 9 plantas. (Ver ley completa)",
            "Transporta hasta 40 gramos. (Ver ley completa)",
            "Transporta hasta 6 goteros. (Ver ley completa)"
        ]
    },

    {
        nombreCard: ["Renovación"],
        listadoBeneficios: [
            "Configuramos tu cuenta de Reprocann por vos.",
            "Gestión del tramite Reprocann.",
            "Consulta médica.",
            "Atención y asesoramiento continúo con nuestro equipo de asistentes por WhatsApp",
            "Acompañamiento en el trámite hasta obtener el permiso.",
            "Posibilidad de cultivo de hasta 9 plantas. (Ver ley completa)",
            "Transportá hasta 40 gramos. (Ver ley completa)",
            "Transportá hasta 6 goteros. (Ver ley completa)",
            "Te guiamos por llamada telefónica personalizada."
        ]
    }

];

export default infoCards;